// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Y4Et","rightAdornment":"Header_rightAdornment__2xV7Y"};